export function isStringArray(arr: unknown[]): arr is string[] {
  return arr && arr.length > 0 && !!arr[0] && typeof arr[0] === 'string';
}

export function isRecordTypeArray(
  arr: unknown[],
): arr is Record<string, unknown>[] {
  return (
    arr &&
    arr.length > 0 &&
    !!arr[0] &&
    typeof arr[0] === 'object' &&
    !Array.isArray(arr[0])
  );
}
